import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { loadEcwid } from "@/lib/ecwid";
import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Delivery from "@/pages/Delivery";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import HowToOrder from "@/pages/HowToOrder";
import Checkout from "@/pages/Checkout";
import Landing from "@/pages/Landing";
import ServiceAreas from "@/pages/ServiceAreas";
import ShopIndex from "@/pages/ShopIndex";
import { LANDING_PAGES } from "@/data/landingPages";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const t = setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: "instant" }), 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}

function NotFound() {
  return (
    <main className="mx-auto max-w-7xl px-4 py-32 text-center sm:px-6" data-testid="not-found-page">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-neutral-500">404</p>
      <h1 className="mt-3 font-display text-4xl font-black tracking-tighter">Page not found</h1>
      <Link to="/shop" className="mt-8 inline-block rounded-full bg-brand-lime px-8 py-3.5 text-sm font-bold text-brand-ink">
        BACK TO SHOP
      </Link>
    </main>
  );
}

function App() {
  useEffect(() => {
    loadEcwid().catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <AgeGate />
          <Header />
          <div className="pb-16 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<ShopIndex />} />
              <Route path="/shop/all" element={<Shop />} />
              <Route path="/category/:slug" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/delivery" element={<Delivery />} />
              <Route path="/how-to-order" element={<HowToOrder />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              {LANDING_PAGES.map((p) => (
                <Route key={p.slug} path={`/${p.slug}`} element={<Landing data={p} />} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
          <CartDrawer />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
